import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { ToggleService } from '../../services/toggle/toggle.service';
import { Institution } from '../../modules/datamodel/institution';
import { User } from '../../modules/datamodel/user';
import { AuthService } from '../../services/auth/auth.service';
import { StateService } from '../../services/state/state.service';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    public user: User;
    public selectedInstitution: Institution;

    public disabled = false;
    public status: {
        isopen: boolean
    } = {
            isopen: false
        };

    constructor(public afAuth: AngularFireAuth, public auth: AuthService, private state: StateService, private router: Router, public toggle: ToggleService) {
        auth
            .user
            .subscribe(user => this.user = user);

        state
            .selectedInstitution
            .subscribe(si => this.selectedInstitution = si);
    }

    setInstitution(value) {
        console.log(value);
        this
            .state
            .setSelectedInstitutionPath(value);
    }

    public toggled(open: boolean): void {
        console.log('Dropdown is now: ', open);
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    ngOnInit(): void { }

    public logout() {
        console.log('logging out');
        this
            .auth
            .logout();
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/sidebar/sidebar.component.ts